<script>
import Detail from './Detail.svelte';
import { version } from '~/../package.json';

const [, hash] = window.location.pathname.split('/');
const identity = loadJSON('/api/identity');

const connection = identity
  .then(() => 'okay')
  .catch(error => {
    if (error instanceof TypeError) return 'failed';
    return 'okay';
  });

const latest_cache = !window.caches ? 'none'
  : window.caches.keys().then(keys => {
    return keys.reduce((acc, k) => {
      if (!k.startsWith(hash)) return acc;
      if (!acc || k > acc) return k;
      return acc;
    }, null);
  });

const server_version = identity
  .then(x => `${x.version} · ${x.startDateTime}`)
  .catch(() => 'unknown');

async function loadJSON (url, options = {}) {
  const res = await fetch(url, options);
  const json = await res.json();

  if (res.ok) {
    return json;
  } else {
    throw new Error(`Loading '${url}' failed`);
  }
}
</script>

<Detail label="Connection">
  <span>
    {#await connection}
      <i class="connection checking" /> checking…
    {:then status}
      <i class="connection {status}" /> {status}
    {/await}
  </span>
</Detail>

<Detail label="Event">{new Date().toUTCString()}</Detail>
<Detail label="Instance">{hash}</Detail>
<Detail label="SW Cache">
  {#await latest_cache then x}
    {x}
  {/await}
</Detail>

<Detail label="App Version">{version}</Detail>

<Detail label="Server Version">
  {#await server_version}
    checking…
  {:then version}
    {version}
  {/await}
</Detail>

<style>
  .connection {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 100px;
  }
  .connection.checking { background-color: goldenrod; }
  .connection.failed { background-color: tomato; }
  .connection.okay { background-color: greenyellow; }
</style>
